module.exports = __webpack_public_path__ + "static/media/137042132-1.92046ee9.mp4";